import React from 'react';
import { Box, FormControlLabel, Grid, Typography } from '@mui/material';
import { TerminalDetailsDto } from '../../../models/terminals/terminalDetailsDto';
import AcceptLabel from '../../common/labels/AcceptLabel';
import DenyLabel from '../../common/labels/DenyLabel';
import { DateUtils } from '../../../helpers/dateUtils';
import { ShowForRole } from '../../common/permissions/ShowForRole';
import { RoleType } from '../../../models/enums/roleType';
import { TmSwitch } from '../../common/TmSwitch';

type ToggleHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface GeneralInfoCardProps {
  terminal?: TerminalDetailsDto;
  onIntegrityCheckChange: ToggleHandler;
  onVerifyRepeatCheckupsChange: ToggleHandler;
}

export const GeneralInfoCard: React.FC<GeneralInfoCardProps> = ({
  terminal,
  onIntegrityCheckChange,
  onVerifyRepeatCheckupsChange
}) => (
  <Box className="gbr" px={2} pb={2} sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Typography variant="h5" fontWeight="bold" sx={{ pt: 2, pb: 1 }}>
      Общая информация
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">ID&nbsp;</Typography><Typography className="rtb">{terminal?.id}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Серийный номер&nbsp;</Typography><Typography className="rtb">{terminal?.number}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">HardwareId&nbsp;</Typography><Typography className="rtb">{terminal?.hardwareId}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Название&nbsp;</Typography><Typography className="rtb">{terminal?.name}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Дата создания&nbsp;</Typography><Typography className="rtb">{terminal?.createdDate ? DateUtils.formatDate(terminal.createdDate) : ""}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Статус&nbsp;</Typography><Typography className="rtb">{terminal?.isActive ? <AcceptLabel>Активен</AcceptLabel> : <DenyLabel>Не активен</DenyLabel>}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Версия ПО&nbsp;</Typography><Typography className="rtb">{terminal?.softwareVersion}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Целостность ПО&nbsp;</Typography><Typography className="rtb">{(!terminal?.performSwIntegrityCheck || terminal?.swIntegrityCheckPassed) ? <AcceptLabel>Не нарушена</AcceptLabel> : <DenyLabel>Нарушена</DenyLabel>}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Адрес&nbsp;</Typography><Typography className="rtb">{terminal?.address}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Координаты&nbsp;</Typography><Typography className="rtb">{terminal?.latitude && terminal?.longitude ? `${terminal.latitude}, ${terminal.longitude}` : ''}</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', mb: 0 }}><Typography className="ltb" variant="body1">Описание терминала&nbsp;</Typography><Typography className="rtb">{terminal?.description}</Typography></Box>
        </Box>
      </Grid>
      <Grid item xs={6}>
        <ShowForRole role={RoleType.Admin}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <FormControlLabel
              label={<Typography className="ltb" variant="body1" sx={{ fontSize: '14px', pt: 0 }}>Режим тестирования</Typography>}
              labelPlacement="start"
              control={<TmSwitch checked={!terminal?.performSwIntegrityCheck} onChange={onIntegrityCheckChange} />}
              sx={{ pt: 0, '& .MuiFormControlLabel-label': { flex: 1 } }}
            />
            <FormControlLabel
              label={<Typography className="ltb" variant="body1" sx={{ fontSize: '14px', pt: 0 }}>Контроль повторных осмотров</Typography>}
              labelPlacement="start"
              control={<TmSwitch checked={terminal?.verifyRepeatCheckups} onChange={onVerifyRepeatCheckupsChange} />}
              sx={{ pt: 0, '& .MuiFormControlLabel-label': { flex: 1 } }}
            />
          </Box>
        </ShowForRole>
      </Grid>
    </Grid>
  </Box>
);
